import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { COLORS } from '@/utils';
import React from 'react';
import { useSelector } from 'react-redux';
import Spinner from '../r3f-components/components/Spinner';
const LoadingSpinners = ({ spinnerDataArray, isScreenRelativeSpinners }) => {
    const isScreenRelativeMode = useSelector((state) => state.userReducer.isScreenRelativeMode);
    // const activeTrackingType = useGetActiveSceneTrackingType()
    const _spinnerDataArray = spinnerDataArray.filter(spinnerData => spinnerData.isScreenRelative === isScreenRelativeSpinners);
    const scale = (isScreenRelativeMode ? [0.1, 0.1, 0.1] : [0.5, 0.5, 0.5]);
    // if (activeTrackingType && !isScreenRelativeMode) scale = [0.1, 0.1, 0.1] as ITuple3
    return (_jsx(_Fragment, { children: _spinnerDataArray.map((spinnerData, index) => {
            const coords = spinnerData.coords;
            const position = isScreenRelativeSpinners ? coords : [coords[0], 0.5, coords[2]];
            return _jsx("group", { position: position, children: _jsx(Spinner, { opacity: 1, radiansPerFrame: 0.06, color: COLORS.nebula, scale: scale, renderOrder: Infinity, depthWrite: false }) }, index);
        }) }));
};
export default LoadingSpinners;
